<template>
  <v-card class="ml-2 mb-2 rounded-lg" elevation="12">
    <h2 class="tw-text-center mt-2 mb-0">Sales by Type</h2>
    <CreditCardBrandCountWidget />
  </v-card>
</template>

<script>
import CreditCardBrandCountWidget from '@/common/components/CreditCardBrandCountWidget.vue';

export default {
  components: {
    CreditCardBrandCountWidget,
  },
};
</script>
